module.exports = __webpack_public_path__ + "img/roxo.png";